import React from 'react';
import { Alert, AlertTitle, Collapse } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { getConfigAmbiente } from '../../services/authentication/auth';

const AlertErroMain = ({
  exibeErro = false,
  escondeErro,
  titleErro = '',
  msgErro = '',
  tipoAlerta = 'error',
  classes = ''
}) => {
  const [lstMsgErro, setLstMsgErro] = React.useState([]);
  const configAmbiente = getConfigAmbiente();
  const emailSuporte = `${
    configAmbiente && configAmbiente.sistema && configAmbiente.sistema.email_suporte
      ? configAmbiente.sistema.email_suporte
      : process.env.REACT_APP_EMAIL_SUPORTE
  }@${
    configAmbiente && configAmbiente.sistema && configAmbiente.sistema.dominio_padrao_email_suporte
      ? configAmbiente.sistema.dominio_padrao_email_suporte
      : process.env.REACT_APP_MAIL_DOMINIO_PADRAO_SUPORTE
  }`;

  React.useEffect(() => {
    const arrayErro = [];
    if (exibeErro && exibeErro.data && exibeErro && exibeErro.data.errors) {
      const erros = Object.values(exibeErro && exibeErro.data.errors);
      erros.map(ers => {
        ers.map(er => {
          arrayErro.push(er);
          return er;
        });
        return ers;
      });
      setLstMsgErro(arrayErro ? arrayErro : []);
    } else if (typeof exibeErro === 'string') {
      setLstMsgErro([exibeErro]);
    }
  }, [exibeErro]);

  return (
    <Collapse in={exibeErro !== false}>
      <Alert
        severity={tipoAlerta}
        action={
          exibeErro && (
            <IconButton
              size="small"
              onClick={() => {
                escondeErro(false);
              }}
              sx={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1000
              }}
            >
              <CloseIcon />
            </IconButton>
          )
        }
        sx={{
          marginTop: '20px',
          width: '100%',
          display: 'flex',
          minHeight: '50px',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          position: 'relative'
        }}
        className={classes}
      >
        <AlertTitle>
          <b>
            {titleErro
              ? titleErro
              : lstMsgErro.length > 0
                ? 'Dados informados inválidos'
                : 'Ocorreu um erro'}
          </b>
        </AlertTitle>

        {msgErro ? (
          msgErro
        ) : lstMsgErro.length > 0 ? (
          <>
            {lstMsgErro.map(er => (
              <span key={`erro_${er}`}>
                <>{er}</>
                <br />
              </span>
            ))}
          </>
        ) : (
          <span>
            Estamos trabalhando para corrigir o problema no nosso sistema.
            <br />
            Tente novamente mais tarde ou
            <a
              href={`mailto:${emailSuporte}`}
              className="link-email-suporte"
              target="_blank"
              rel="noreferrer"
            >
              &nbsp;fale com a gente&nbsp;
            </a>
            para obter ajuda.
          </span>
        )}
      </Alert>
    </Collapse>
  );
};

export default AlertErroMain;
